import * as tagColor from './CountTag.module.scss';

import { CountTag } from './CountTag';
import { TagOutlined } from '@ant-design/icons';
import { TooltipPlacement } from 'antd/es/tooltip';

import React, { memo } from 'react';

export interface TagCountTagProps {
	count: number;
	tooltip?: string | React.ReactNode | (() => React.ReactNode);
	tooltipPlacement?: TooltipPlacement;
}

export const TagCountTag: React.FC<TagCountTagProps> = memo(({ count, ...props }) => {
	const tagCount = count > 0 ? count : undefined;

	return (
		<CountTag
			color={ tagColor.tagCount }
			count={ tagCount }
			icon={ <TagOutlined /> }
			{ ...props } />
	);
});
